import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { Column } from '../../common/DataTable';
import { PortalUserListItem } from '../../store/modules/merchant/types';
import { getPortalUserRoleLabel } from './portalUserRoleCatalog';

export const formatPortalUserLastLogin = (lastLogin?: string): string =>
  lastLogin ? dayjs(lastLogin).format('MM/DD/YY hh:mm A') : '—';

const PortalUserRolesCell = ({ roles }: { roles: PortalUserListItem['roles'] }) => {
  if (!roles.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {roles.map((role) => (
        <Chip
          key={role.id}
          label={getPortalUserRoleLabel(role.name)}
          size="small"
          variant="outlined"
        />
      ))}
    </Stack>
  );
};

export const getSharedPortalUserColumns = (): Column<PortalUserListItem>[] => [
  {
    id: 'email',
    headerName: 'Email',
    valueGetter: (row) => row.email,
    sortable: true,
    sortName: 'email',
    minWidth: 220,
  },
  {
    id: 'firstName',
    headerName: 'First name',
    renderCell: (row) => (
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
        {row.givenName ?? '—'}
      </Typography>
    ),
    sortable: true,
    sortName: 'givenName',
    minWidth: 100,
  },
  {
    id: 'lastName',
    headerName: 'Last name',
    renderCell: (row) => (
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
        {row.familyName ?? '—'}
      </Typography>
    ),
    sortable: true,
    sortName: 'familyName',
    minWidth: 100,
  },
  {
    id: 'roles',
    headerName: 'Roles',
    renderCell: (row) => <PortalUserRolesCell roles={row.roles ?? []} />,
    minWidth: 160,
    width: 200,
  },
  {
    id: 'lastLogin',
    headerName: 'Last login',
    valueGetter: (row) => formatPortalUserLastLogin(row.lastLogin),
    minWidth: 175,
    width: 175,
  },
  {
    id: 'active',
    headerName: 'Active',
    renderCell: (row) => (
      <Chip
        label={row.hasLoggedIn ? 'Yes' : 'No'}
        size="small"
        color={row.hasLoggedIn ? 'success' : 'default'}
        variant={row.hasLoggedIn ? 'filled' : 'outlined'}
      />
    ),
    minWidth: 90,
    maxWidth: 90,
  },
];
